<template>
    <div class="segment-container">
        <div class="sliding-bar" :style="slidingBarStyle"></div>

        <div
            :class="['segment-button', selected == index ? 'selected' : '']"
            v-for="(item, index) in options"
            :key="index"
            @click="selected = index"
        >
            <font-awesome-icon v-if="item.icon" :icon="item.icon" class="segment-icon" />
            <label style="margin: 0px; cursor: pointer; user-select: none;">{{ item.label }}</label>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            options: {
                type: Array,
                default: () => [],
            },
            initialSelection: {
                type: Number,
                default: 0,
            },
        },
        name: 'Segment',
        data() {
            return {
                selected: this.initialSelection,
            };
        },
        computed: {
            slidingBarStyle() {
                const padding = 2;
                const width = `calc(${100 / this.options.length}% - ${2 * padding}px)`;
                const transform = `translateX(calc(${this.selected * 100}% + ${padding}px))`;
                return {
                    width,
                    transform,
                };
            },
        },
        watch: {
            selected(val) {
                this.$emit('selected', val);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .segment-button {
        flex: 1;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        cursor: pointer;
        position: relative;
        z-index: 1;
    }

    .segment-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        height: 35px;
        border: 1px solid #dee2e6;
        background-color: #cbcbcb;
        border-radius: 5px;
        margin: 5px;
        position: relative;
        padding: 2px;
    }

    .segment-icon {
        margin-right: 8px;
    }

    .sliding-bar {
        position: absolute;
        height: calc(100% - 6px);
        transition: transform 0.3s ease;
        border: 1px #dee2e6 solid;
        background-color: #f0f0f0;
        border-radius: 5px;
        z-index: 0;
    }
</style>